import CalendarSelectionLayout from './CalendarSelectionLayout';

const CalendarSelection: React.FC = () => {
  return <CalendarSelectionLayout />;
};

export default CalendarSelection;
